/**
 * dropdown-account.js
 */

import React, { useContext } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import BarButton from '../bar-button';
import Icon from 'components/icon';
import DropMenu from 'components/drop-menu';
import { AuthContext } from 'contexts/auth/auth-context';
import { UserContext } from 'contexts/user/user-context';
import { Link } from 'react-router-dom';


const useStyles = makeStyles(theme => ({
  text: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    marginRight: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  welcome: {
    fontSize: theme.typography.overline.fontSize,
    textTransform: 'uppercase',
    color: theme.palette.comp.navBar.onSurfaceVariant,
    letterSpacing: '0.1em',
    marginRight: '-2px',
  },
  name: {
    fontSize: theme.typography.sizes[2],
  },
}));


export default function AccountMenu(props) {
  const classes = useStyles();
  const { logout } = useContext(AuthContext);
  const { user, admin } = useContext(UserContext);

  // build drop-menu items
  const items = [];
  items.push({
    key: 'profile',
    name: 'Profile',
    icon: 'profile',
    component: Link,
    to: '/profile' 
  });
  if (user.role.isHandler || user.role.isTrainer){
    items.push({
      key: 'history',
      name: 'History',
      icon: 'history',
      component: Link,
      to: '/history'
    });
  }
  items.push({ id: 'divider' });
  if (admin) {
    items.push({
      key: 'admin-report-monitor',
      name: 'Report Monitor',
      icon: 'todo',
      component: Link,
      to: '/admin/report-monitor'
    });
    items.push({
      key: 'user-admin',
      name: 'User Admin',
      icon: 'user-admin',
      component: Link,
      to: '/admin/user'
    });
    items.push({
      key: 'tracking-admin',
      name: 'Tracking Admin',
      icon: 'tracking-admin',
      component: Link,
      to: '/admin/tracking'
    });
    items.push({ id: 'divider' });
  }
  items.push({
    key: 'logout',
    name: 'Logout',
    icon: 'logout',
    onSelect: () => logout()
  });


  return (
    <>
      <DropMenu
        id="account"
        label={(
          <BarButton
            edge="end"
            wide
          >
            <div className={classes.text}>
              <div className={classes.welcome}>Welcome</div>
              <div className={classes.name}>{user.firstName}</div>
            </div>        
            <Icon type='profile' />
          </BarButton>
        )}
        aria-label="user account menu"
        items={items}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      />
    </>
  );
}